module.exports = "/images/green-tick.svg?02f59c2dab69db019edc867538d1f931";